/**
 * Hoe een feedregel eruitziet: het merkteken, de toon en of hij oplicht.
 *
 * Regel voor regel dezelfde tabel als FeedLook.kt op Android. Losstaand omdat
 * dit precies de laag is die stilletjes verrotte: het scherm koos zijn
 * pictogram op `kind`, `kind` werd de categorie van de gebeurtenissenlaag, en
 * geen enkele soort stond nog in de tabel. Niets brak — er stond alleen op elke
 * regel dezelfde grijsgroene stip, terwijl de server negen verschillende
 * iconen meestuurde. Een test op een pure functie merkt dat; een scherm niet.
 */

// De toon, als naam en niet als kleur: de kleuren staan in het palet van het
// scherm en hier zou een tweede waarheid ontstaan.
const TONE = {
  incident: "sit",
  omgeving: "sit",
  verkeer: "werk",
  weer: "weer",
  evenement: "evt",
  // De twee soorten uit de blokken die geen gebeurtenis zijn.
  situatie: "sit",
  werk: "werk",
};

// Waar het scherm op terugvalt als een bericht geen icoon draagt. Het icoon
// komt van de server: die kent het type en de client niet.
const FALLBACK_MARK = { situatie: "▲", werk: "▦", weer: "❄" };

/** Wat voorbij is, is groen — welke soort het ook was. */
export const feedTone = (item) =>
  item.status === "resolved" ? "done" : TONE[item.kind] || "done";

export const feedMark = (item) =>
  item.icon || FALLBACK_MARK[item.kind] || "◉";

/** Wanneer een regel oplicht: op de ernst, en niet als het al voorbij is. */
export const feedUrgent = (item) =>
  item.status !== "resolved"
  && ((item.severity || 0) >= 4 || item.kind === "situatie");
